// 取得兌換商品清單
export class GetRedeemItemList {
  static readonly type = '[VenderRedeem] GetRedeemItemList';
}

// 兌換商品
export class DoRedeemItem {
  static readonly type = '[VenderRedeem] DoRedeemItem';
  constructor(public payload: any) {}
}

// 取得兌換商品紀錄
export class GetRedeemItemLog {
  static readonly type = '[VenderRedeem] GetRedeemItemLog';
}
